import * as React from 'react';
import { TooltipDesktop, UIText2 } from '@cian/ui-kit';

import { ReliableLabel } from './ReliableLabel';

import * as styles from './styles.css';

export interface IReliableLabelTooltipProps {
  onOpen(): void;
  onClick(event: React.MouseEvent<HTMLElement>): void;
}

export function ReliableLabelTooltip({ onOpen, onClick }: IReliableLabelTooltipProps) {
  return (
    <TooltipDesktop
      theme="black"
      title={
        <div className={styles['tooltip']}>
          <UIText2 color="text-inverted-default">Подробнее о надёжности</UIText2>
        </div>
      }
    >
      <ReliableLabel onOpen={onOpen} onClick={onClick} />
    </TooltipDesktop>
  );
}
